import React, { useEffect } from "react";
import "./centroinnovacion.css";

const CentroInnovacion = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="container centroinnovacion-container">
      <div className='row'>
            <div className='col_12'>
                <div className='centroinnovacion_title'>
                    <h1>Servicios</h1>
                </div>
            </div>
        </div>
     
      <hr className="hr-gob" />
    </div>
  );
};

export default CentroInnovacion;
